import { apiRequest } from '../../../api/client';
import type { AuditLogEntry, AuditLogFilters } from '../../../api/types';

// PARA-106, AC-9: фильтры date_from/date_to/admin_id/action_type — опциональны.
export async function fetchAuditLog(filters: AuditLogFilters): Promise<AuditLogEntry[]> {
  const params = new URLSearchParams();
  if (filters.date_from) params.set('date_from', filters.date_from);
  if (filters.date_to) params.set('date_to', filters.date_to);
  if (filters.admin_id !== undefined) params.set('admin_id', String(filters.admin_id));
  if (filters.action_type) params.set('action_type', filters.action_type);

  const query = params.toString();
  return apiRequest<AuditLogEntry[]>(`/admin/audit-log${query ? `?${query}` : ''}`);
}
